import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import BaseUrl from "../../base-api";
import AxiosInstance from "../Utility/AxiosInstance";
import { isloading } from "../redux/reducer/LoadingReducer";
import FormField from "./FormField";

const DISCHARGE_DOC_TYPE = "DISCHARGE_PDF";

export function findSavedDischargeDoc(documents = []) {
  return documents.find((doc) => doc.docName === DISCHARGE_DOC_TYPE) || null;
}

const DischargeDocumentField = ({
  label = "Upload Discharge/Retirement Book",
  savedDoc,
  selectedFile,
  isReplacing,
  error,
  accept = ".pdf",
  onStartReplace,
  onCancelReplace,
  onFileChange,
}) => {
  const dispatch = useDispatch();
  const [pdfSrc, setPdfSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const viewDocument = async (docId) => {
    try {
      dispatch(isloading());
      const res = await AxiosInstance.get(`${BaseUrl}/api/auth/document/${docId}`, {
        headers: { "Content-Type": "application/json" },
        responseType: "arraybuffer",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      setPdfSrc(URL.createObjectURL(blob));
      setShowModal(true);
    } catch (err) {
      toast.error(err.response?.data?.message || "Unable to view document");
    } finally {
      dispatch(isloading());
    }
  };

  const showUpload = !savedDoc || isReplacing;

  return (
    <div>
      <label className="form-label">{label}</label>

      {savedDoc && !isReplacing && (
        <div className="border rounded p-3 mb-2 bg-light">
          <p className="mb-2 small text-muted">
            Uploaded: {savedDoc.fileName || "Discharge/Retirement Book"}
          </p>
          <div className="d-flex gap-2 flex-wrap">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => viewDocument(savedDoc.docId)}
            >
              View
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={onStartReplace}
            >
              Replace
            </button>
          </div>
        </div>
      )}

      {showUpload && (
        <>
          {isReplacing && savedDoc && (
            <div className="d-flex justify-content-end mb-2">
              <button
                type="button"
                className="btn btn-link btn-sm p-0"
                onClick={onCancelReplace}
              >
                Cancel replace
              </button>
            </div>
          )}
          <FormField
            label=""
            name="dischargePdf"
            type="file"
            onChange={onFileChange}
            error={error}
            accept={accept}
            required={!savedDoc || isReplacing}
            value={selectedFile ? "" : undefined}
          />
          <p className="text-muted small mb-0">PDF only, maximum 1 MB</p>
          {selectedFile && (
            <div className="mt-2 text-muted small">
              Selected file: {selectedFile.name}
            </div>
          )}
        </>
      )}

      {error && !showUpload && <div className="text-danger small mt-1">{error}</div>}

      <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="xl">
        <ModalHeader toggle={() => setShowModal(false)}>
          Discharge/Retirement Book
        </ModalHeader>
        <ModalBody style={{ height: "80vh" }}>
          {pdfSrc && (
            <iframe
              src={pdfSrc}
              title="Discharge document"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DischargeDocumentField;
